import ceoProfile from '../../../images/company-board-ceo.png'
import cooProfile from '../../../images/company-board-coo.png'
import hirotaProfile from '../../../images/company-board-hirota.png'

export const leaderships = [
  {
    company: 'IVA株式会社',
    profile: ceoProfile,
    title: '代表取締役CEO',
    name: '相原 嘉夫',
    position: '代表取締役 執行役員 CEO',
    intro:
      '1995年生まれ。青山学院大学大学院国際マネジメント研究科修了、MBA取得。大学在学中にコマース領域で起業し、事業売却を経験。2019年、AI真贋鑑定サービス「FAKEBUSTERS」を創業し、IVA株式会社を設立。日本語・中国語のバイリンガル。「Forbes JAPAN 30 Under 30 2023」「Forbes 30 Under 30 Asia 2024」に選出。',
    socialUrl: 'https://x.com/YoshioAihara'
  },
  {
    company: 'IVA株式会社',
    profile: cooProfile,
    title: '取締役 執行役員COO',
    name: 'ジェイ・ルー',
    position: '取締役 執行役員 COO 兼 SVP of Authentication 兼 中国法人代表',
    intro:
      '1995年生まれ。広東外語外貿大学(GUFS)で、中国市場、経営管理を研究後、来日。2019年 IVA株式会社を相原と共に創業し、COOとして事業戦略、組織管理、中国開発拠点の立ち上げを牽引するなど幅広い領域で会社のグロースをサポート。中国語・日本語のバイリンガル。'
  },
  {
    company: '社外取締役',
    profile: hirotaProfile,
    title: '社外取締役',
    name: '廣田 航輝',
    position: '千葉道場ファンド ジェネラルパートナー',
    intro:
      '大阪市立大学商学部卒業後、2017年にSBIインベストメントに入社。一貫してベンチャーキャピタルの投資業務に従事。リードインベスターとして幅広いステージの投資を担当。その後2020年11月千葉道場ファンドに参画。千葉道場ファンドではファンド組成、投資先のソーシング、投資先の支援、レポーティング業務を担当。2024年、千葉道場ファンドジェネラルパートナーに就任。'
  }
]
